<template>
  <component :is="closeable ? 'closeable-filter-badge-container' : 'filter-badge-container'"
             class="filter-menu-element hover:bg-primary-light hover:text-primary-focus"
             @remove="onRemove"
  >
    <filter-value class="ml-3" :label="label" :label-classes="labelClasses">
      <slot />
    </filter-value>
  </component>
</template>

<script>
import FilterBadgeContainer from './FilterBadgeContainer.vue'
import CloseableFilterBadgeContainer from './CloseableFilterBadgeContainer.vue'
import FilterValue from './FilterValue.vue'

export default {
  name: 'FilterBadge',

  components: { FilterBadgeContainer, FilterValue, CloseableFilterBadgeContainer },

  props: {
    label: {
      type: String,
      required: true
    },
    labelClasses: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onRemove() {
      if (!this.closeable) return

      this.$emit('remove')
    }
  }
}
</script>
